export enum TeamMemberFieldNameDTO {
  // INFO section
  STATUS = 'STATUS',
  DEPARTMENT = 'DEPARTMENT',
  ROLE = 'ROLE',
  SENIORITY = 'SENIORITY',
  LOCATION = 'LOCATION',
  MANAGER = 'MANAGER',
  IS_MANAGER = 'IS_MANAGER',
  MEMBERSHIP_TYPE = 'MEMBERSHIP_TYPE',
  // CAPACITY section
  CAPACITY = 'CAPACITY',
  TOTAL_WORKING_MINUTES = 'TOTAL_WORKING_MINUTES',
  ON_DEMAND = 'ON_DEMAND',
  // BILLING section
  INTERNAL_RATE = 'INTERNAL_RATE',
  EXTERNAL_RATE = 'EXTERNAL_RATE',
  IS_HOURLY_RATED = 'IS_HOURLY_RATED',
  CURRENCY = 'CURRENCY',
  // INTEGRATION section
  GOOGLE = 'GOOGLE',
  JIRA = 'JIRA',
  QUICK_BOOKS = 'QUICK_BOOKS',
  TEMPO = 'TEMPO',
  CLOCKIFY = 'CLOCKIFY',
  BAMBOOHR = 'BAMBOOHR',
}

/** Virtual field name used for the computed corporate function capacity row (not from backend). */
export const CORPORATE_FUNCTION_CAPACITY_FIELD = 'CORPORATE_FUNCTION_CAPACITY';

export enum TeamMemberFieldValueDTO {}
// Placeholder for future use

export interface TeamMemberChangedFieldResponse {
  fieldName: TeamMemberFieldNameDTO;
  fieldLocalizedName?: string | null;
  oldValue?: string | null;
  oldValueKey?: TeamMemberFieldValueDTO | null;
  newValue?: string | null;
  newValueKey?: TeamMemberFieldValueDTO | null;
  subfieldChanges?: TeamMemberChangedFieldResponse[] | null;
}
